import React from 'react';
import ReactDOM from 'react-dom';
import {Link, Redirect} from 'react-router-dom';
import Loader from './Loader';
import AppHeader2 from './AppHeader2';

class SearchLocation extends React.Component {
    constructor(props) {
        //console.log(props);
        super(props);
        this.state = {
            LOADING: true,
            addressChanged: false, 
            CustomerAddresses: '',
            delCIRCLEUpdated: false
        };
    }

    fetchCustomerAddress(mode,customer) {
        var that = this;
        fetch('https://m.donedelivery.in/api/customeraddress_api2.php?mode='+mode+'&customer='+customer,{
            mode: 'cors',
            credentials: 'same-origin',
            headers: {
                'Access-Control-Allow-Origin': '*', 
                Accept: 'application/json', 
                'Content-Type': 'application/json',
            },
        }).then(function (response) {
            return response.json();
        }).then(function (result) {
            //console.log(result);
            
            let customer_addresses = result.addresses;
            if(customer_addresses=='' || customer_addresses==undefined)
                customer_addresses = '';

            that.setState({ LOADING:false, CustomerAddresses:customer_addresses });
        });
    }

    handleGetNewAddressDelCircle = (address_id,circle_id,circleID2) => {
        let allowAddressChange = 'Y';
        let cartCIRCLE = localStorage.getItem('cartCIRCLE');
        let resID = circleID2;
        if(cartCIRCLE !== null && cartCIRCLE!=='{}')
        {
            if(circle_id!=cartCIRCLE)
                allowAddressChange = 'N';
        }

        //console.log(allowAddressChange);

        //allowAddressChange = 'Y';
        if(allowAddressChange=='N')
            $('#ModalOtherDelCircleData_'+address_id).modal('show');
        else
        {
            localStorage.setItem('addressID', address_id);
            localStorage.setItem('delCIRCLE',circle_id);
            localStorage.setItem('delCIRCLE2',circleID2);
            localStorage.setItem('GPS','N');
            this.setState({ delCIRCLEUpdated:true });
        }
    }

    handleGetNewAddressDelCircle2 = (address_id,circle_id,circleID2) => {
        localStorage.removeItem('cartCIRCLE');
        localStorage.removeItem('cartData');
        localStorage.removeItem('addressID');
        localStorage.removeItem('AnikZai');
        localStorage.removeItem('cartVendorID');
        localStorage.removeItem('cartVendorName');
        localStorage.removeItem('cartVendorTypeID');

        localStorage.setItem('addressID', address_id);
        localStorage.setItem('delCIRCLE',circle_id);
        localStorage.setItem('delCIRCLE2',circleID2);
        localStorage.setItem('GPS','N');
        this.setState({ delCIRCLEUpdated:true });
    }

    componentWillMount() {
        let mount = $("div").hasClass("modal-backdrop");
        if(mount==true)
        {
            $('body').removeClass('modal-open');
            $(".modal-backdrop").remove();
            //window.location.reload(true);
        }
    }

    componentDidMount() {
        let customer = '';
        let delcity = '';
        let delarea = '';

        if(localStorage.getItem('userData'))
            customer = localStorage.getItem('userData');

        let circle_id = localStorage.getItem('delCIRCLE');
        this.fetchCustomerAddress('ADDRESS',customer);
    }

    render() { 

        //localStorage.removeItem("userData");
        //localStorage.removeItem("cartData");
        //localStorage.removeItem("delCity");
        //localStorage.removeItem("delArea");
        //console.log(localStorage.getItem('userData'));

        if(this.state.delCIRCLEUpdated==true)
        {
            if(localStorage.getItem('delCIRCLE') && localStorage.getItem('delCIRCLE')!=null)
            {
                return (<Redirect to={'/home'}/>)
            }
        }

        let logged = 'N';
        if(localStorage.getItem('userData'))
            logged = 'Y';

        if(logged=='N')
        {
            return (<Redirect to={'/map'}/>)
        }

        let address_id = '';
        if(localStorage.getItem('addressID')!=null)
            address_id = localStorage.getItem('addressID');

        let AppHeaderClass = 'appHeader bg-dark text-light';
        let AppHeaderLeft = 'showLINK';
        let AppHeaderLeftLink = '/home';
        let AppHeaderTitle = 'Search Location';
        let AppHeaderRight = '';
        let AppHeaderRightLink = '';
        let AppHeaderSearch = '';

        return (
            <div>
                {this.state.LOADING && <Loader />}
                <AppHeader2 AppHeaderClass={AppHeaderClass} AppHeaderLeft={AppHeaderLeft} AppHeaderLeftLink={AppHeaderLeftLink} AppHeaderTitle={AppHeaderTitle} AppHeaderRight={AppHeaderRight} AppHeaderRightLink={AppHeaderRightLink} AppHeaderSearch={AppHeaderSearch}/>
                <div id="appCapsule">
                    <div className="delivery-location section full mt-0">
                        {this.state.CustomerAddresses.length>0 && this.state.CustomerAddresses.map(post => {
                            let checked = false;
                            if(address_id!='' && address_id==post.ID)
                                checked = true;
                            else
                            {
                                if(post.DEFAULT=='Y')
                                    checked = true;
                            }

                            return (
                                <div key={post.ID}>
                                    <div className="wide-block pt-2 pb-2">
                                        <div className="sumup">
                                            <div className="custom-control custom-radio">
                                                <input type="radio" id={`address_${post.ID}`} name="address" value={post.ID} className="custom-control-input" defaultChecked={checked} onClick={()=>{this.handleGetNewAddressDelCircle(post.ID,post.CIRCLE_ID,post.CIRCLE_ID2)}}/>
                                                <label className="custom-control-label" htmlFor={`address_${post.ID}`}>
                                                    <h5 className="font-weg-400 mb-05">{post.CIRCLE}
                                                        <span className="badge chip-warning chip-outline ht-17 font-size-10  font-weg-500 text-upper ltsp">{post.LABEL}</span>
                                                    </h5>
                                                    <p className="font-size-13l font-weg-300 mb-05">{post.ADDRESS}</p>
                                                    {post.MOBILE_NO && <div className="stateline pin">
                                                        <span className="text-lgrey font-size-12 mb-05 mr-1">{post.MOBILE_NO}</span>
                                                    </div>}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal fade dialogbox" id={`ModalOtherDelCircleData_${post.ID}`} data-backdrop="static" tabIndex="-1" role="dialog">
                                        <div className="modal-dialog" role="document">
                                            <div className="modal-content">
                                            <div className="modal-header">
                                                <h5 className="modal-title">&nbsp;</h5>
                                            </div>
                                            <div className="modal-body"> Your cart contains dishes from another location. The cart will be deleted, proceed? </div>
                                            <div className="modal-footer">
                                                <div className="btn-inline">
                                                    <button className="btn btn-text-success" data-dismiss="modal" onClick={()=>{this.handleGetNewAddressDelCircle2(post.ID,post.CIRCLE_ID,post.CIRCLE_ID2)}}>Yes</button>
                                                    <button type="button" className="btn btn-text-danger" data-dismiss="modal">No</button>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>                 
                            );
                        }) }
                    </div>
                    <div className="form-button-group1 pr-2 pl-2">
                        <div className="col-12">
                            <div className="text-upper">
                                <div className="row">
                                    <div className="col-12">
                                        <Link to="/map" className="btn newshadowed font-size-14 square btn-danger btn-ssm btn-block">USE CURRENT LOCATION</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
  
export default SearchLocation;


// WEBPACK FOOTER //
// ./src/components/SearchLocation.js